










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ContainerExpand extends Vue {
	@Prop() public targets!: string | null;
	@Prop({ default: 'main' }) public mainElementId!: string;
	@Prop({ default: 'aside' }) public asideElementId!: string;
	@Prop({ default: 3 }) public asideNormalColumnWidth!: number;

	private isExpanding = false;

	public shrinkGrow (): void {
		this.isExpanding = !this.isExpanding;
	}

	@Watch('isExpanding')
	private applyContainerClass (isExpanding: boolean) {
		const main = document.getElementById('main');
		const aside = document.getElementById('aside');

		if (main == null || aside == null) {
			console.warn(`No #${this.mainElementId} or #${this.asideElementId} found within document`);
			return;
		}

		if (isExpanding) {
			main.classList.replace(`col-lg-${12 - this.asideNormalColumnWidth}`, 'col-lg-12');
			aside.classList.replace(`col-lg-${this.asideNormalColumnWidth}`, 'd-none');
		} else {
			main.classList.replace('col-lg-12', `col-lg-${12 - this.asideNormalColumnWidth}`);
			aside.classList.replace('d-none', `col-lg-${this.asideNormalColumnWidth}`);
		}
	}
}
